<div class="message-box mb-20">
  <div class="box-1">
    <div class="icon-background display-flex justify-content flex-align-center">
      <mat-icon class="mat-icon">info</mat-icon>
    </div>
  </div>
  <div class="box-2 flex-grow">
    <div class="display-flex">
      <div class="flex-grow">
        <strong>Information</strong>
      </div>
      <div *ngIf="dropdown">
        <ng-container [ngSwitch]="show">
          <mat-icon class="mat-icon cursor" *ngSwitchCase="true" (click)="onToggle()">keyboard_arrow_down</mat-icon>
          <mat-icon class="mat-icon cursor" *ngSwitchCase="false" (click)="onToggle()">keyboard_arrow_up</mat-icon>
        </ng-container>
      </div>
    </div>
    <ng-container [ngSwitch]="show">
      <ng-container *ngSwitchCase="true">
        <ng-content></ng-content>
      </ng-container>
      <ng-container *ngSwitchCase="false">
        <ng-content select="[showmessage]"></ng-content>
      </ng-container>
    </ng-container>
  </div>
</div>
